import React, { useState, useRef } from 'react';
import { MoveHorizontal } from 'lucide-react';
import '../styles/ComparisonSlider.css';

const ComparisonSlider = ({ beforeImage, afterImage }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleMove = (clientX) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = (x / rect.width) * 100;

    setSliderPosition(Math.min(Math.max(percentage, 0), 100));
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    handleMove(e.touches[0].clientX);
  };

  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove);
      document.addEventListener('touchend', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleMouseUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDragging]);

  return (
    <div className="comparison-slider-container" ref={containerRef}>
      <div className="comparison-images">
        {/* Before Image (3D Render) */}
        <div className="before-image-container">
          <img src={beforeImage} alt="Before - 3D Render" className="comparison-image" />
          <div 
            className="image-label label-before"
            style={{ opacity: sliderPosition < 15 ? 0 : 1, transition: 'opacity 0.3s ease' }}
          >
            <span className="body-medium">2D Drawing</span>
          </div>
        </div>

        {/* After Image (2D Blueprint) */}
        <div
          className="after-image-container"
          style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
        >
          <img src={afterImage} alt="After - 2D Blueprint" className="comparison-image" />
        </div>
      </div>

      {/* 3D Reality label - positioned outside clipped container */}
      <div 
        className="image-label label-after-overlay"
        style={{ opacity: sliderPosition > 85 ? 0 : 1, transition: 'opacity 0.3s ease' }}
      >
        <span className="body-medium">3D Reality</span>
      </div>

      {/* Slider Handle */}
      <div
        className="slider-handle"
        style={{ left: `${sliderPosition}%` }}
        onMouseDown={handleMouseDown}
        onTouchStart={() => setIsDragging(true)}
      >
        <div className="slider-line"></div>
        <div className="slider-button">
          <MoveHorizontal size={24} />
        </div>
      </div>
    </div>
  );
};

export default ComparisonSlider;